import alertsENUM, { HIDE_ALERT_MODALS_SESSION_KEY } from '@/constants/alerts';
import { IRouterProps } from '@/router/interfaces/router-props.interface';
import { getPropsFromRoute } from '@/router/router-utils';
import AlertsService from '@/api/AlertsService';
import { Route } from 'vue-router';
import store from '@/store';

const alertService = new AlertsService();

class AlertModals {
  initialize(to: Route) {
    store.watch(
      (s, getters) => getters['business/getBusinessState'],
      () => this.openIfPossible(getPropsFromRoute(to))
    );
  }

  private openIfPossible(routerProps: IRouterProps) {
    if (
      this.isFirstAlertToBeShown() &&
      routerProps.auth === 'manager' &&
      routerProps.routeRequirements.managerHaveBusiness
    ) {
      this.open();
    }
  }

  private async open() {
    sessionStorage.setItem(HIDE_ALERT_MODALS_SESSION_KEY, 'yes');

    const alerts = await alertService.listAlerts();
    const loyaltyAlert = alerts.find(
      alert => alert.type === 'loyalty_popup' && alert.status === 'active'
    );
    const squareAlert = alerts.find(
      alert => alert.type === 'square_popup' && alert.status === 'active'
    );
    if (this.isAlertNotYetFetched(alertsENUM.LOYALTY) && loyaltyAlert) {
      store.dispatch('business/PUSH_ALERT', {
        type: alertsENUM.LOYALTY,
        active: true
      });
    } else if (this.isAlertNotYetFetched(alertsENUM.SQUARE) && squareAlert) {
      store.dispatch('business/PUSH_ALERT', {
        type: alertsENUM.SQUARE,
        active: true
      });
    }
  }

  private isFirstAlertToBeShown() {
    // Makes sure we do mot show multiple alerts in the same session
    return !sessionStorage.getItem(HIDE_ALERT_MODALS_SESSION_KEY);
  }

  private isAlertNotYetFetched(alertType: string) {
    return store.getters['business/getAlertsType'].includes(alertType);
  }
}

export default new AlertModals();
